import "./FoodToolbar.css";

import {
  MdSearch,
  MdRefresh,
  MdFilterAlt,
} from "react-icons/md";

function FoodToolbar({
  search,
  setSearch,

  category,
  setCategory,

  foodType,
  setFoodType,

  availability,
  setAvailability,

  categories = [],

  refreshFoods,
}) {
  return (
    <div className="food-toolbar">

      <div className="food-search">

        <MdSearch />

        <input
          type="text"
          placeholder="Search food..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      <div className="food-filters">

        <div className="filter-box">

          <MdFilterAlt />

          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">All Categories</option>

            {categories.map((cat) => (
              <option
                key={cat}
                value={cat}
              >
                {cat}
              </option>
            ))}

          </select>

        </div>

        <select
          value={foodType}
          onChange={(e) => setFoodType(e.target.value)}
        >
          <option value="">All Types</option>
          <option value="Veg">Veg</option>
          <option value="Non-Veg">Non Veg</option>
          <option value="Egg">Egg</option>
          <option value="Vegan">Vegan</option>
        </select>

        <select
          value={availability}
          onChange={(e) => setAvailability(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="Available">Available</option>
          <option value="Unavailable">Unavailable</option>
        </select>

        <button
          className="food-refresh-btn"
          onClick={refreshFoods}
        >
          <MdRefresh />
          Refresh
        </button>

      </div>

    </div>
  );
}

export default FoodToolbar;